import { LoadableElement } from '@99designs/common/components/LoadableElement';
import {
    CreateBrief as CreateBriefInterface,
    CreateBriefVariables,
} from '__generated__/CreateBrief';
import { StructuredBriefFieldsInput } from '__generated__/types';
import { routes } from 'projects/routes';
import { parseQueryString } from 'projects/routes/BriefEntry';
import { history } from 'projects/routes/BrowserRouter';
import { CallFnOnMount } from 'projects/util/mount';
import React, { useState } from 'react';
import { Mutation, MutationResult } from 'react-apollo';
import { useLocation } from 'react-router';
import mutation from './CreateBrief.graphql';

export interface ChildProps {
    fields: StructuredBriefFieldsInput;
}

interface Props {
    children: (
        mutation: (variables: ChildProps, mode?: 'push' | 'replace') => void,
        result: MutationResult
    ) => React.ReactElement;
}

export default function CreateBrief({ children }: Props) {
    const location = useLocation();
    const [, setState] = useState();
    const { designerId } = parseQueryString(location.search);

    return (
        <Mutation<CreateBriefInterface, CreateBriefVariables> mutation={mutation}>
            {(mutation, result) => {
                return children(({ fields }, mode = 'push') => {
                    const designerIds = designerId ? [designerId] : [];

                    mutation({
                        variables: {
                            fields,
                            designerIds,
                        },
                    })
                        .then(res => {
                            if (res) {
                                const brief = res.data!.createStructuredBrief;
                                history[mode](routes.briefStep(brief, 1));
                            }
                        })
                        .catch(e => {
                            setState(() => {
                                throw e;
                            });
                        });
                }, result);
            }}
        </Mutation>
    );
}

export function CreateBriefOnMount(variables: ChildProps) {
    return (
        <CreateBrief>
            {mutation => (
                <CallFnOnMount onMount={() => mutation(variables, 'replace')}>
                    <LoadableElement variations={['fade-in']} isLoading={true} />
                </CallFnOnMount>
            )}
        </CreateBrief>
    );
}
